import { create, valueOf, Any } from 'microstates';
import { NOOP } from '../lib/constants';

export default class ExternalActionsState {
  backAction = Any;
  forwardAction = Any;
  backText = String;
  forwardText = String;

  initialize({ backAction, forwardAction } = {}) {
    let i = this;
    i = backAction ? i.backAction.set(backAction) : i.backAction.set(NOOP);
    i = forwardAction ? i.forwardAction.set(forwardAction) : i.forwardAction.set(NOOP);
    return i;
  }

  back(x) {
    return this.backAction.state(x);
  }

  forward(x) {
    return this.forwardAction.state(x);
  }
}
